import { Package } from "components/icons/generated";
import useModuleSearchForNavigation from "shared/Module/useSearchForNavigation";

import CommandPaletteEntitySearch from "./EntitySearch";

const useSearchHook = ({ query }: { query: string }) => {
  return useModuleSearchForNavigation({ query });
};

const CommandPaletteSubListViewModulesSearch = () => (
  <CommandPaletteEntitySearch
    useSearchHook={useSearchHook}
    icon={Package}
    pathPrefix="/module/"
    entityName="modules"
  />
);

export default CommandPaletteSubListViewModulesSearch;
